import { analysts } from "../LandingPage/analystsJson";

export const NAV_LINKS = [
  { label: "Public Blog", to: "/blogs/public" },
  { label: "Member Content", to: "/blogs/premium" },
  { label: "Alerts", to: "/alerts" },
  { label: "Analysts", to: "/analysts" },
  { label: "Education", to: "/education" },
  { label: "FAQ", to: "/faq" },
  { label: "4 Year Journey", to: "/4yearcycle" },
];

/** Prod sidebar extras: CMS for admin + publisher; Admin for admin only. */
export const CMS_NAV_LINK = { label: "CMS", to: "/cms" };
export const ADMIN_NAV_LINK = { label: "Admin", to: "/admin" };

export const getRoleNavLinks = (user) => {
  const roleId = user?.userRoleId;
  if (roleId === 1) return [CMS_NAV_LINK, ADMIN_NAV_LINK];
  if (roleId === 3) return [CMS_NAV_LINK];
  return [];
};

export const HERO_STATS = [
  { icon: "group", label: "10K+ Subscribers", sublabel: "Worldwide" },
  { icon: "trending_up", label: "$2B+", sublabel: "Member Portfolio Value" },
  { icon: "shield", label: "7 Analysts", sublabel: "World-Class Experts" },
  { icon: "play_circle", label: "100+", sublabel: "Videos Monthly" },
];

/** Prod LandingPage hero / sale promo Wistia — sample analysis CTA. */
export const HOMEPAGE_SAMPLE_WISTIA_ID = "fwaxun2z59";

export const TRACK_RECORD_STATS = [
  { icon: "calendar_today", value: "8+", label: "Years Active" },
  { icon: "trending_up", value: "3", label: "Bull & Bear Cycles" },
  { icon: "emoji_events", value: "#1", label: "Longest Running" },
];

export const FEATURES = [
  {
    icon: "videocam",
    title: "Daily Video Analysis",
    description:
      "Multiple video updates every day covering market movements, breaking news, and strategic opportunities.",
  },
  {
    icon: "notifications",
    title: "Real-Time Alerts",
    description:
      "Instant notifications on major market moves, opportunities, and critical events that affect your portfolio.",
  },
  {
    icon: "bar_chart",
    title: "Deep Research",
    description:
      "Institutional-grade research reports with actionable insights and detailed market analysis.",
  },
  {
    icon: "forum",
    title: "Live Q&A Sessions",
    description:
      "Regular interactive sessions where you can ask our analysts your specific questions directly.",
  },
  {
    icon: "lock",
    title: "Ask the Analysts",
    description:
      "Post your questions directly on any video and hear feedback straight from our analysts — every conversation happens right where the analysis lives.",
  },
  {
    icon: "public",
    title: "24/7 Crypto Coverage",
    description:
      "Our team covers the crypto markets around the clock across every time zone, so you never miss a critical move.",
  },
];

const LOVABLE_ANALYST_META = [
  {
    key: "Peter brandt",
    displayName: "Peter Brandt",
    title: "Veteran Trader & Market Wizard",
    bio: "Trader for five decades. Featured Market Wizard and acclaimed author of classical charting principles.",
    specialty: "Classical Charting",
  },
  {
    key: "Bob Loukas",
    displayName: "Bob Loukas",
    title: "Bitcoin 4-Year Cycle Pioneer",
    bio: "Father of the Bitcoin 4-Year Cycle framework with 30+ years of trading experience across global markets.",
    specialty: "Bitcoin Cycles",
  },
  {
    key: "Big Cheds",
    displayName: "Big Cheds",
    title: "Technical Analysis Author",
    bio: "Best-selling author with 20+ years of trading experience. Renowned for clear, actionable technical analysis.",
    specialty: "Technical Analysis",
  },
  {
    key: "Aksel Kibar",
    displayName: "Aksel Kibar",
    title: "CMT, Former Fund Manager",
    bio: "Classical charting specialist and former institutional fund manager. CMT charterholder with global market expertise.",
    specialty: "Classical Charting",
  },
  {
    key: "CtheLightTrading",
    displayName: "CtheLight Trading",
    title: "Position Trading Veteran",
    bio: "30-year trading veteran specializing in position trading and long-term market structure analysis.",
    specialty: "Position Trading",
  },
  {
    key: "Mark Dukas",
    displayName: "Mark Dukas",
    title: "Algorithmic Trading Specialist",
    bio: "Deep crypto market experience combined with algorithmic trading systems and quantitative strategies.",
    specialty: "Algorithmic Trading",
  },
  {
    key: "On-Chain College",
    displayName: "OnChain College",
    title: "On-Chain Analyst & Author",
    bio: "Leading on-chain analyst and published author. Decodes blockchain data into actionable Bitcoin insights.",
    specialty: "On-Chain Analytics",
  },
];

export const HOMEPAGE_ANALYSTS = LOVABLE_ANALYST_META.map((meta) => {
  const source = analysts.find((a) => a.name === meta.key);
  return {
    name: meta.displayName,
    profilePic: source?.profilePic,
    title: meta.title,
    bio: meta.bio,
    specialty: meta.specialty,
  };
}).filter((a) => a.profilePic);


export const FOOTER_LINKS = [
  { title: "Terms & Conditions", to: "/terms&conditions" },
  { title: "Privacy Policy", to: "/policy" },
];

export const PLAN_FEATURES = [
  "Access to all 7 analysts",
  "100+ videos monthly",
  "Daily video commentary on Bitcoin & crypto",
  "Real-time market alerts",
  "Ask analysts questions directly on every post",
  "Price lock for the life of your subscription",
];

const getMonthsInCycle = (billingCycle) => {
  if (billingCycle === 12 || billingCycle === 365) return 12;
  if (billingCycle === 3 || billingCycle === 92) return 3;
  if (billingCycle === 1 || billingCycle === 30) return 1;
  return null;
};

const PLAN_SORT_ORDER = {
  1: 0,
  30: 0,
  3: 1,
  92: 1,
  12: 2,
  365: 2,
};

export const sortPlansByCycle = (plans) =>
  [...plans].sort(
    (a, b) =>
      (PLAN_SORT_ORDER[a.billingCycle] ?? 99) -
      (PLAN_SORT_ORDER[b.billingCycle] ?? 99)
  );

export const getPlanPeriod = (billingCycle) => {
  const months = getMonthsInCycle(billingCycle);
  if (months === 12) return "/year";
  if (months === 3) return "/quarter";
  if (months === 1) return "/month";
  return "";
};

export const getMonthlyEquivalent = (cost, billingCycle) => {
  const months = getMonthsInCycle(billingCycle);
  if (!months || months <= 1) return null;
  return Math.round(cost / months);
};
